import BaseFeature from '../../foundation/base/base';

class CourseDetailsSummary extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.map = this.el;
		this.body = window.features.dom.body;
		this.textSingleAccordionButton = this.el.querySelector('[data-js="textSingleAccordionButton"]');
		this.toggleButton = this.el.querySelector('[data-js="toggleButton"]');
		this.addClick();
	}

	toggleButtonLabel(button, attributeValue) {
		this.button = button;
		const textSingleAccordionButtonLabel = this.button.querySelector(`[data-js="${attributeValue}"]`);
		const textSingleAccordionButtonCollapseTitle = this.button.getAttribute('data-collapse');
		const textSingleAccordionButtonExpandTitle = this.button.getAttribute('data-expand');
		if (textSingleAccordionButtonLabel.innerHTML === textSingleAccordionButtonCollapseTitle) {
			textSingleAccordionButtonLabel.innerHTML = textSingleAccordionButtonExpandTitle;
			button.setAttribute('title', textSingleAccordionButtonExpandTitle);
		} else {
			textSingleAccordionButtonLabel.innerHTML = textSingleAccordionButtonCollapseTitle;
			button.setAttribute('title', textSingleAccordionButtonCollapseTitle);
		}
	}

	toggle(button) {
		this.button = button;
		if (this.button.classList.contains('on')) {
			this.button.classList.remove('on');
			this.button.classList.add('off');
		} else {
			this.button.classList.remove('off');
			this.button.classList.add('on');
		}
	}

	addClick() {
		// Expand submenu
		if (this.textSingleAccordionButton) {
			this.textSingleAccordionButton.addEventListener('click', () => {
				this.el.classList.toggle('is-folded-content');
				this.toggleButtonLabel(this.textSingleAccordionButton, 'textSingleAccordionButtonLabel');

				// Accessibility
				let elementState = this.textSingleAccordionButton.getAttribute('aria-expanded');
				if (elementState === 'true') {
					elementState = 'false';
				} else {
					elementState = 'true';
				}
				this.textSingleAccordionButton.setAttribute('aria-expanded', elementState);
			});
			window.addEventListener('keydown', (e) => {
				const isFocused = document.activeElement === this.textSingleAccordionButton;
				if (isFocused && e.keyCode === 13) {
					e.preventDefault();
					// Trigger the button element with a click
					this.textSingleAccordionButton.click();
				}
			});
		}

		if (this.toggleButton) {
			this.toggleButton.addEventListener('click', () => {
				this.el.classList.toggle('is-folded-content');
				this.toggle(this.toggleButton);
				this.toggleButtonLabel(this.toggleButton, 'toggleButtonLabel');

				// Accessibility
				let elementState = this.toggleButton.getAttribute('aria-expanded');
				if (elementState === 'true') {
					elementState = 'false';
				} else {
					elementState = 'true';
				}
				this.toggleButton.setAttribute('aria-expanded', elementState);
			});
			window.addEventListener('keydown', (e) => {
				const isFocused = document.activeElement === this.toggleButton;
				if (isFocused && e.keyCode === 13) {
					e.preventDefault();
					// Trigger the button element with a click
					this.toggleButton.click();
				}
			});
		}
	}
}

export default CourseDetailsSummary;
